export const headerConfig = {
    accessPlatformLabel: "Access Platform",
    aiGuidanceLabel: "AI Guidance",
    logoutLabel: "Log out"
};